import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ModalService } from '../../modals/modal.service';
import { NewFolderDialogComponent } from '../new-folder-dialog/new-folder-dialog.component';

@Component({
  selector: 'new-folder-button',
  imports: [MatButtonModule, MatIconModule],
  providers: [ModalService],
  templateUrl: './new-folder-button.component.html',
  styleUrl: './new-folder-button.component.scss',
  standalone: true,
})
export class NewFolderButtonComponent {
  @Input() parentId: string = '';
  @Input() existingFiles: any[] = [];
  @Input() kind: string = '';
  @Output() folderAdded = new EventEmitter<void>();

  constructor(private modalService: ModalService) {}

  openNewFolderModal() {
    this.modalService
      .showDialog(NewFolderDialogComponent, {
        parentId: this.parentId,
        existingFiles: this.existingFiles,
        kind: this.kind,
      })
      .then((folderName: string) => {
        Boolean(folderName) && this.folderAdded.emit();
      })
      .catch(() => {});
  }
}
